import axios from 'axios';

let prefix = "/saga"

const SagaApi = {
	listSaga(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getSagaInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	archiveSaga(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createSaga(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateSaga(payload) {
		return axios.post(prefix + "/update", payload)
	},
}

export default SagaApi;